// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import './global.less';
import router from './router'
import Global from './Global'

const bus = new Vue();
Vue.prototype.$bus = bus
export default bus;

Vue.config.productionTip = false
Vue.prototype.$global = Global;  //定义全局变量Global，用于传递参数
Vue.use(Antd);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js